/* ------------------------------------------------------------------
   Pulp — scroll-triggered motion
   ------------------------------------------------------------------
   Adds .is-go to any element carrying data-pulp-reveal the first time
   it scrolls into view. The CSS in pulp-brand.css keys every reveal
   (roast curve, roast stamp) off that class, so:

   • No JS, no IntersectionObserver → nothing is hidden, it just renders.
   • prefers-reduced-motion → the CSS shows the finished state; this
     script still adds the class so nothing waits on it.
   • Re-runs on Shopify's section:load so it plays when a merchant drags
     the section around in the theme editor.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  function all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function arm(root) {
    var nodes = all('[data-pulp-reveal]:not(.is-armed)', root);
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-armed', 'is-go'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-go');
        io.unobserve(e.target);
      });
    }, { threshold: 0.35 });

    nodes.forEach(function (n) {
      n.classList.add('is-armed');
      io.observe(n);
    });
  }

  function replay(root) {
    all('[data-pulp-reveal]', root).forEach(function (n) {
      n.classList.remove('is-go', 'is-armed');
    });
    arm(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { arm(document); });
  } else {
    arm(document);
  }

  document.addEventListener('shopify:section:load', function (e) { replay(e.target); });
  document.addEventListener('shopify:section:select', function (e) { replay(e.target); });
})();
